"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionMessage = exports.SyntheticMessage = exports.SynthFields = exports.SignatureRequest = exports.SignatureMessage = exports.SequencedMessage = exports.NetworkUpdate = exports.MakeMajorBlock = exports.Envelope = exports.DidUpdateExecutorVersion = exports.CreditPayment = exports.BlockAnchor = exports.BadSyntheticMessage = void 0;
const _1 = require(".");
const txid_1 = require("../address/txid");
const url_1 = require("../address/url");
const buffer_1 = require("../common/buffer");
const protocol = __importStar(require("../core"));
const encoding_1 = require("../encoding");
class BadSyntheticMessage {
    constructor(args) {
        this.type = _1.MessageType.BadSynthetic;
        this.message = args.message == undefined ? undefined : _1.Message.fromObject(args.message);
        this.signature =
            args.signature == undefined ? undefined : protocol.KeySignature.fromObject(args.signature);
        this.proof =
            args.proof == undefined
                ? undefined
                : args.proof instanceof protocol.AnnotatedReceipt
                    ? args.proof
                    : new protocol.AnnotatedReceipt(args.proof);
    }
    copy() {
        return new BadSyntheticMessage(this.asObject());
    }
    asObject() {
        return {
            type: "badSynthetic",
            message: this.message && this.message.asObject(),
            signature: this.signature && this.signature.asObject(),
            proof: this.proof && this.proof.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], BadSyntheticMessage.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], BadSyntheticMessage.prototype, "message", void 0);
__decorate([
    encoding_1.encodeAs.field(3).union
], BadSyntheticMessage.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).reference
], BadSyntheticMessage.prototype, "proof", void 0);
exports.BadSyntheticMessage = BadSyntheticMessage;
class BlockAnchor {
    constructor(args) {
        this.type = _1.MessageType.BlockAnchor;
        this.signature =
            args.signature == undefined ? undefined : protocol.KeySignature.fromObject(args.signature);
        this.anchor = args.anchor == undefined ? undefined : _1.Message.fromObject(args.anchor);
    }
    copy() {
        return new BlockAnchor(this.asObject());
    }
    asObject() {
        return {
            type: "blockAnchor",
            signature: this.signature && this.signature.asObject(),
            anchor: this.anchor && this.anchor.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], BlockAnchor.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], BlockAnchor.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(3).union
], BlockAnchor.prototype, "anchor", void 0);
exports.BlockAnchor = BlockAnchor;
class CreditPayment {
    constructor(args) {
        this.type = _1.MessageType.CreditPayment;
        this.paid = args.paid == undefined ? undefined : protocol.Fee.fromObject(args.paid);
        this.payer = args.payer == undefined ? undefined : url_1.AccumulateURL.parse(args.payer);
        this.initiator = args.initiator == undefined ? undefined : args.initiator;
        this.txID = args.txID == undefined ? undefined : txid_1.AccumulateTxID.parse(args.txID);
        this.cause = args.cause == undefined ? undefined : txid_1.AccumulateTxID.parse(args.cause);
    }
    copy() {
        return new CreditPayment(this.asObject());
    }
    asObject() {
        return {
            type: "creditPayment",
            paid: this.paid && protocol.Fee.getName(this.paid),
            payer: this.payer && this.payer.toString(),
            initiator: this.initiator && this.initiator,
            txID: this.txID && this.txID.toString(),
            cause: this.cause && this.cause.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], CreditPayment.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], CreditPayment.prototype, "paid", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], CreditPayment.prototype, "payer", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bool
], CreditPayment.prototype, "initiator", void 0);
__decorate([
    encoding_1.encodeAs.field(5).txid
], CreditPayment.prototype, "txID", void 0);
__decorate([
    encoding_1.encodeAs.field(6).txid
], CreditPayment.prototype, "cause", void 0);
exports.CreditPayment = CreditPayment;
class DidUpdateExecutorVersion {
    constructor(args) {
        this.type = _1.MessageType.DidUpdateExecutorVersion;
        this.partition = args.partition == undefined ? undefined : args.partition;
        this.version =
            args.version == undefined ? undefined : protocol.ExecutorVersion.fromObject(args.version);
    }
    copy() {
        return new DidUpdateExecutorVersion(this.asObject());
    }
    asObject() {
        return {
            type: "didUpdateExecutorVersion",
            partition: this.partition && this.partition,
            version: this.version && protocol.ExecutorVersion.getName(this.version),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], DidUpdateExecutorVersion.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], DidUpdateExecutorVersion.prototype, "partition", void 0);
__decorate([
    encoding_1.encodeAs.field(3).enum
], DidUpdateExecutorVersion.prototype, "version", void 0);
exports.DidUpdateExecutorVersion = DidUpdateExecutorVersion;
class Envelope {
    constructor(args) {
        this.signatures =
            args.signatures == undefined
                ? undefined
                : args.signatures.map((v) => v == undefined ? undefined : protocol.Signature.fromObject(v));
        this.txHash =
            args.txHash == undefined
                ? undefined
                : args.txHash instanceof Uint8Array
                    ? args.txHash
                    : buffer_1.Buffer.from(args.txHash, "hex");
        this.transaction =
            args.transaction == undefined
                ? undefined
                : args.transaction.map((v) => v == undefined
                    ? undefined
                    : v instanceof protocol.Transaction
                        ? v
                        : new protocol.Transaction(v));
        this.messages =
            args.messages == undefined
                ? undefined
                : args.messages.map((v) => (v == undefined ? undefined : _1.Message.fromObject(v)));
    }
    copy() {
        return new Envelope(this.asObject());
    }
    asObject() {
        return {
            signatures: this.signatures && this.signatures?.map((v) => (v == undefined ? undefined : v.asObject())),
            txHash: this.txHash && this.txHash && buffer_1.Buffer.from(this.txHash).toString("hex"),
            transaction: this.transaction &&
                this.transaction?.map((v) => (v == undefined ? undefined : v.asObject())),
            messages: this.messages && this.messages?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).repeatable.union
], Envelope.prototype, "signatures", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], Envelope.prototype, "txHash", void 0);
__decorate([
    encoding_1.encodeAs.field(3).repeatable.reference
], Envelope.prototype, "transaction", void 0);
__decorate([
    encoding_1.encodeAs.field(4).repeatable.union
], Envelope.prototype, "messages", void 0);
exports.Envelope = Envelope;
class MakeMajorBlock {
    constructor(args) {
        this.type = _1.MessageType.MakeMajorBlock;
        this.majorBlockIndex = args.majorBlockIndex == undefined ? undefined : args.majorBlockIndex;
        this.minorBlockIndex = args.minorBlockIndex == undefined ? undefined : args.minorBlockIndex;
        this.majorBlockTime =
            args.majorBlockTime == undefined
                ? undefined
                : args.majorBlockTime instanceof Date
                    ? args.majorBlockTime
                    : new Date(args.majorBlockTime);
    }
    copy() {
        return new MakeMajorBlock(this.asObject());
    }
    asObject() {
        return {
            type: "makeMajorBlock",
            majorBlockIndex: this.majorBlockIndex && this.majorBlockIndex,
            minorBlockIndex: this.minorBlockIndex && this.minorBlockIndex,
            majorBlockTime: this.majorBlockTime && this.majorBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], MakeMajorBlock.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], MakeMajorBlock.prototype, "majorBlockIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], MakeMajorBlock.prototype, "minorBlockIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(4).time
], MakeMajorBlock.prototype, "majorBlockTime", void 0);
exports.MakeMajorBlock = MakeMajorBlock;
class NetworkUpdate {
    constructor(args) {
        this.type = _1.MessageType.NetworkUpdate;
        this.accounts =
            args.accounts == undefined
                ? undefined
                : args.accounts.map((v) => v == undefined
                    ? undefined
                    : v instanceof protocol.NetworkAccountUpdate
                        ? v
                        : new protocol.NetworkAccountUpdate(v));
    }
    copy() {
        return new NetworkUpdate(this.asObject());
    }
    asObject() {
        return {
            type: "networkUpdate",
            accounts: this.accounts && this.accounts?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], NetworkUpdate.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.reference
], NetworkUpdate.prototype, "accounts", void 0);
exports.NetworkUpdate = NetworkUpdate;
class SequencedMessage {
    constructor(args) {
        this.type = _1.MessageType.Sequenced;
        this.message = args.message == undefined ? undefined : _1.Message.fromObject(args.message);
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.destination = args.destination == undefined ? undefined : url_1.AccumulateURL.parse(args.destination);
        this.number = args.number == undefined ? undefined : args.number;
    }
    copy() {
        return new SequencedMessage(this.asObject());
    }
    asObject() {
        return {
            type: "sequenced",
            message: this.message && this.message.asObject(),
            source: this.source && this.source.toString(),
            destination: this.destination && this.destination.toString(),
            number: this.number && this.number,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], SequencedMessage.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], SequencedMessage.prototype, "message", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], SequencedMessage.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], SequencedMessage.prototype, "destination", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], SequencedMessage.prototype, "number", void 0);
exports.SequencedMessage = SequencedMessage;
class SignatureMessage {
    constructor(args) {
        this.type = _1.MessageType.Signature;
        this.signature =
            args.signature == undefined ? undefined : protocol.Signature.fromObject(args.signature);
        this.txID = args.txID == undefined ? undefined : txid_1.AccumulateTxID.parse(args.txID);
    }
    copy() {
        return new SignatureMessage(this.asObject());
    }
    asObject() {
        return {
            type: "signature",
            signature: this.signature && this.signature.asObject(),
            txID: this.txID && this.txID.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], SignatureMessage.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], SignatureMessage.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(3).txid
], SignatureMessage.prototype, "txID", void 0);
exports.SignatureMessage = SignatureMessage;
class SignatureRequest {
    constructor(args) {
        this.type = _1.MessageType.SignatureRequest;
        this.authority = args.authority == undefined ? undefined : url_1.AccumulateURL.parse(args.authority);
        this.txID = args.txID == undefined ? undefined : txid_1.AccumulateTxID.parse(args.txID);
        this.cause = args.cause == undefined ? undefined : txid_1.AccumulateTxID.parse(args.cause);
    }
    copy() {
        return new SignatureRequest(this.asObject());
    }
    asObject() {
        return {
            type: "signatureRequest",
            authority: this.authority && this.authority.toString(),
            txID: this.txID && this.txID.toString(),
            cause: this.cause && this.cause.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], SignatureRequest.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], SignatureRequest.prototype, "authority", void 0);
__decorate([
    encoding_1.encodeAs.field(3).txid
], SignatureRequest.prototype, "txID", void 0);
__decorate([
    encoding_1.encodeAs.field(4).txid
], SignatureRequest.prototype, "cause", void 0);
exports.SignatureRequest = SignatureRequest;
class SynthFields {
    constructor(args) {
        this.message = args.message == undefined ? undefined : _1.Message.fromObject(args.message);
        this.signature =
            args.signature == undefined ? undefined : protocol.KeySignature.fromObject(args.signature);
        this.proof =
            args.proof == undefined
                ? undefined
                : args.proof instanceof protocol.AnnotatedReceipt
                    ? args.proof
                    : new protocol.AnnotatedReceipt(args.proof);
    }
    copy() {
        return new SynthFields(this.asObject());
    }
    asObject() {
        return {
            message: this.message && this.message.asObject(),
            signature: this.signature && this.signature.asObject(),
            proof: this.proof && this.proof.asObject(),
        };
    }
}
exports.SynthFields = SynthFields;
class SyntheticMessage {
    constructor(args) {
        this.type = _1.MessageType.Synthetic;
        this.message = args.message == undefined ? undefined : _1.Message.fromObject(args.message);
        this.signature =
            args.signature == undefined ? undefined : protocol.KeySignature.fromObject(args.signature);
        this.proof =
            args.proof == undefined
                ? undefined
                : args.proof instanceof protocol.AnnotatedReceipt
                    ? args.proof
                    : new protocol.AnnotatedReceipt(args.proof);
    }
    copy() {
        return new SyntheticMessage(this.asObject());
    }
    asObject() {
        return {
            type: "synthetic",
            message: this.message && this.message.asObject(),
            signature: this.signature && this.signature.asObject(),
            proof: this.proof && this.proof.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], SyntheticMessage.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], SyntheticMessage.prototype, "message", void 0);
__decorate([
    encoding_1.encodeAs.field(3).union
], SyntheticMessage.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).reference
], SyntheticMessage.prototype, "proof", void 0);
exports.SyntheticMessage = SyntheticMessage;
class TransactionMessage {
    constructor(args) {
        this.type = _1.MessageType.Transaction;
        this.transaction =
            args.transaction == undefined
                ? undefined
                : args.transaction instanceof protocol.Transaction
                    ? args.transaction
                    : new protocol.Transaction(args.transaction);
    }
    copy() {
        return new TransactionMessage(this.asObject());
    }
    asObject() {
        return {
            type: "transaction",
            transaction: this.transaction && this.transaction.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.MessageType)
], TransactionMessage.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], TransactionMessage.prototype, "transaction", void 0);
exports.TransactionMessage = TransactionMessage;
//# sourceMappingURL=types_gen.js.map